<div class="modal-body">
  <div class="content">
    <!-- Main step with form -->
    <section *ngIf="step === 'form'">
      <div class="content__top">
        <h4 translate>company.connectivity.add-connection-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <div class="content__main">
        <form [formGroup]="form">
          <div class="link-label-container">
            <label class="vox-field-label" translate>company.connectivity.add-connection-popup.form.provider.label</label>
            <button class='vox-btn link-btn' tabindex="-1" type="button" (click)="step = 'explanation'"
            translate>company.connectivity.add-connection-popup.form.provider.how</button>
          </div>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
            'vox-input-group_invalid': isFieldValid('providerReferenceId')}">
            <input class="vox-text-field" type="text"
            id="providerReferenceId" formControlName="providerReferenceId"
            [placeholder]="'company.connectivity.add-connection-popup.form.provider.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>company.connectivity.add-connection-popup.form.required</span>
          </div>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit"
            [disabled]="form.invalid" (click)="addConnection()" [ladda]="loading">
              <span translate>company.connectivity.add-connection-popup.form.submit</span>
            </button>
          </div>
        </form>
      </div>
    </section>
    <!-- Sub step with provider id explanation -->
    <section *ngIf="step === 'explanation'">
      <div class="content__top">
        <i class="icon-small-back" (click)="step = 'form'"></i>
        <h4 translate>company.connectivity.add-connection-popup.provider-id-explanation.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <div class="content__main">
        <p class="content__main--text" translate>company.connectivity.add-connection-popup.provider-id-explanation.text-1</p>
        <p class="content__main--text"
        [innerHTML]="'company.connectivity.add-connection-popup.provider-id-explanation.text-2' | translate"></p>
        <img src="assets/img/how-to-get-provider-id-1.png" alt="" class="content__main--img">
        <p class="content__main--text" translate>company.connectivity.add-connection-popup.provider-id-explanation.text-3</p>
        <img src="assets/img/how-to-get-provider-id-2.png" alt="" class="content__main--img">
        <div class="submit-container">
          <button class="vox-btn vox-btn-secondary-dark-grey" (click)="step = 'form'"
            translate>company.connectivity.add-connection-popup.provider-id-explanation.close</button>
        </div>
      </div>
    </section>
  </div>
</div>